import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { QRCodeCanvas } from "qrcode.react";
import CountUp from "../components/countUp";
import "./home.css";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import axios from "axios";
import bgImage from "../../src/public/assets/img/Home-Page-Parallax.jpg";

const Home = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [about_data, setAboutData] = useState({});
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [sliders, setSliders] = useState([]);
  const [homeProducts, setHomeProducts] = useState([]);
  const [featureProducts, setFeatureProducts] = useState([]);
  const whatsappNumber = "919876543210";

  const instagramItems = [
    {
      id: 1,
      type: "story",
      label: "CUTLERY",
      imageUrl: "assets/img/instagram-product/cutlery.jpg",
      href: "https://www.instagram.com/stories/highlights/17992659008836513/",
      width: "89%",
    },
    {
      id: 2,
      type: "story",
      label: "MELAMINE",
      imageUrl: "assets/img/instagram-product/melamine.jpg",
      href: "https://www.instagram.com/stories/highlights/18003125312600679/",
    },
    {
      id: 3,
      type: "story",
      label: "PORCELAIN",
      imageUrl: "assets/img/instagram-product/porcelain.jpg",
      href: "https://www.instagram.com/stories/highlights/18063968291479809/",
    },
    {
      id: 4,
      type: "story",
      label: "PREMIUM CERAMIC",
      imageUrl: "assets/img/instagram-product/ceramic.jpg",
      href: "https://www.instagram.com/stories/highlights/18125839360390629/",
    },
  ];

  const fetchCategories = () => {
    axios
      .post(`${BASE_URL}/api/category/get`)
      .then((response) => {
        if (response.data.category.length > 0) {
          setCategories(response.data.category);
        }
      })
      .catch((err) => {});
  };

  const fetchProducts = () => {
    axios
      .post(`${BASE_URL}/api/product/get`)
      .then((response) => {
        if (response.data.product.length > 0) {
          setProducts(response.data.product);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    fetchProducts();
    fetchHomeProducts();
    fetchFeatureProducts();
    fetchSliders();
    fetchAbouts();
    fetchCategories();
  }, []);

  const fetchAbouts = async () => {
    const response = await axios.post(`${BASE_URL}/api/about/get`);
    setAboutData(response.data.about);
  };

  const fetchSliders = () => {
    axios
      .post(`${BASE_URL}/api/slider/get`)
      .then((response) => {
        if (response.data.slider.length > 0) {
          setSliders(response.data.slider);
        }
      })
      .catch((err) => {});
  };

  const fetchHomeProducts = () => {
    axios
      .post(`${BASE_URL}/api/category/get`)
      .then((response) => {
        if (response.data.category.length > 0) {
          setHomeProducts(response.data.category);
        }
      })
      .catch((err) => {});
  };

  const fetchFeatureProducts = () => {
    axios
      .post(`${BASE_URL}/api/product/getFeature`)
      .then((response) => {
        if (response.data.product.length > 0) {
          setFeatureProducts(response.data.product);
        }
      })
      .catch((err) => {});
  };

  const product_details = [
    {
      name: "Sachi Bonechina",
      link: `${BASE_URL}/product-form?product=bonechina`,
    },
    {
      name: "Sachi Melamine Range",
      link: `${BASE_URL}/product-form?product=melamine`,
    },
    {
      name: "Sachi Porcelain Range",
      link: `${BASE_URL}/product-form?product=sachi_porcelain`,
    },
    {
      name: "Sachi Fine Tableware Range",
      link: `${BASE_URL}/product-form?product=fine_tableware`,
    },
    {
      name: "Packaging Food Container",
      link: `${BASE_URL}/product-form?product=food_package`,
    },
  ];

  const getPlainText = (html = "") => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  return (
    <>
      <main className="main-content">
        <section className="home-slider-area slider-default">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={0}
            slidesPerView={1}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
            loop={true}
            className="mySwiper"
          >
            {sliders.length > 0
              ? sliders.map((item, index) => {
                  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=Hello! I'm interested in ${encodeURIComponent(
                    item.name,
                  )}`;
                  return (
                    <SwiperSlide>
                      <div
                        className="home-slider-item"
                        style={{
                          backgroundImage: `url(https://sachiproduct-backend.theaditech.in/${item.image})`,
                        }}
                      >
                        {/* <div className="slider-overlay">
                          <h2 className="slider-title">{item.name}</h2>
                        </div> */}
                      </div>
                    </SwiperSlide>
                  );
                })
              : ""}
          </Swiper>
        </section>
        <section className="about-home-area about-default-area slider-about">
          <div className="row">
            <div className="col-lg-7 col-md-12">
              <div className="about-content">
                <div className="row">
                  <div className="col-lg-8 m-auto text-center">
                    <div className="section-title">
                      <span className="subtitle">Welcome to</span>
                      <h2 className="title">Sachi Products</h2>
                      <div className="title-separator"></div>
                    </div>
                  </div>
                </div>

                <p
                  style={{
                    whiteSpace: "pre-line",
                    fontSize: "18px",
                    lineHeight: "1.6",
                  }}
                >
                  {(() => {
                    const text = getPlainText(about_data?.description);
                    return text.length > 1000
                      ? `${text.substring(0, 1000)}...`
                      : text;
                  })()}
                </p>

                {/* Read More Button */}
                <Link to="/about" className="read-more-btn">
                  Read More
                </Link>
              </div>
            </div>

            {/* Image */}
            <div className="col-lg-5 col-md-12">
              <div className="video-button-container">
                <img
                  src="assets/img/sachi1.jpg"
                  alt="About Sachi Products"
                  className="img-fluid about-product"
                />

                {/* Video Play Button */}
                <a
                  href="https://www.instagram.com/reel/DUPrljhCQlj/?igsh=MWc3N3dnNmFqMDh6aw=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="video-play-btn"
                >
                  <i className="fa fa-play"></i>
                  <span className="ripple"></span>
                </a>
              </div>
            </div>
          </div>
        </section>
        <section
          className="product-area latest-product-area"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <div className="container">
            {/* <div className="row">
              <div className="col-md-8 col-lg-6 m-auto">
                <div className="section-title text-center">
                  <h2 className="title">Product Categories</h2>
                </div>
              </div>
            </div> */}

            <div className="row">
              <div className="col-lg-8 m-auto text-center">
                <div className="section-title">
                  <h2 className="title">Product Categories</h2>
                  <div className="title-separator"></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="swiper-container product4-slider-container">
                  <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    spaceBetween={0}
                    slidesPerView={4}
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 2000, disableOnInteraction: false }}
                    loop={true}
                    className="myProductSwiperContent"
                  >
                    {homeProducts.map((product, index) => (
                      <SwiperSlide>
                        <div className="product-item">
                          <div className="product-thumb">
                            <Link
                              // to={`/product_images/${product.id}/${product.name}`}
                              to={`/product_by_category/${product.id}`}
                            >
                              <img
                                src={`${BASE_URL}/${product.image}`}
                                // src={`https://sachiproduct-backend.theaditech.in/${product.image}`}
                                alt={product.name}
                                className="product-img"
                              />
                              {/* <div className="ribbons">
                                <span className="ribbon ribbon-hot">Sale</span>
                                <span className="ribbon ribbon-onsale align-right">
                                  -15%
                                </span>
                              </div> */}
                            </Link>
                            <div className="product-action">
                              <Link
                                className="action-quick-view"
                                to={`/product_by_category/${product.id}`}
                                title="Quick View"
                              >
                                <i className="fa fa-opencart"></i>
                              </Link>
                            </div>
                          </div>
                          <div className="product-info">
                            <h4 className="title">
                              <Link to={`/product_by_category/${product.id}`}>
                                {product.name}
                              </Link>
                            </h4>
                          </div>
                        </div>
                        {/* <!-- End Product Item --> */}
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="service-area section-space"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <div className="container">
            {/* Section Header */}
            <div className="row">
              <div className="col-lg-8 m-auto text-center">
                <div className="section-title">
                  <h2 className="title">Our Values</h2>
                  <div className="title-separator"></div>
                </div>
              </div>
            </div>

            <div className="row mt-5">
              {/* Service Item 1 */}
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="service-card">
                  <div className="service-icon">
                    <img src="assets/logos/icon2.png" alt="Timely Service" />
                  </div>
                  <div className="service-content">
                    <h4 className="service-title">Timely Service</h4>
                    <p className="service-desc">
                      A product is only valuable to the consumer if they can use
                      it on time. We ensure our patrons access products in a
                      timely manner.
                    </p>
                  </div>
                </div>
              </div>

              {/* Service Item 2 */}
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="service-card active">
                  <div className="service-icon">
                    <img
                      src="/assets/logos/icon3.png"
                      alt="Transparent Policy"
                    />
                  </div>
                  <div className="service-content">
                    <h4 className="service-title">Transparent Policy</h4>
                    <p className="service-desc">
                      We understand the importance of transparency and
                      accountability to build meaningful, long-term
                      relationships with our stakeholders.
                    </p>
                  </div>
                </div>
              </div>

              {/* Service Item 3 */}
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="service-card">
                  <div className="service-icon">
                    <img
                      src="/assets/logos/icon4.png"
                      alt="Customer Satisfaction"
                    />
                  </div>
                  <div className="service-content">
                    <h4 className="service-title">Customer Satisfaction</h4>
                    <p className="service-desc">
                      All our actions are based on our customers’ needs. We
                      strive to ensure 100% satisfaction through tailored
                      strategies and quality.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section
          className="product-area featured-product-area"
          data-aos="fade-up"
          data-aos-duration="1000"
          style={{ padding: "60px 0px 75px 0px", marginTop: "-60px" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-lg-6 m-auto">
                <div className="text-center">
                  <h2 className="title" style={{ marginBottom: "60px" }}>
                    <strong> Product Details </strong>
                  </h2>
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "30px",
              }}
            >
              <div style={{ width: "150px", textAlign: "center" }}>
                <QRCodeCanvas
                  value={`${window.location.origin}/assets/pdf/bonechina.pdf`}
                  size={80}
                  level="H"
                />
                <p style={{ marginTop: "10px", fontWeight: "500" }}>
                  Bonechina
                </p>
              </div>

              <div style={{ width: "150px", textAlign: "center" }}>
                <QRCodeCanvas
                  value={`${window.location.origin}/assets/pdf/fine_tableware.pdf`}
                  size={80}
                  level="H"
                />
                <p style={{ marginTop: "10px", fontWeight: "500" }}>
                  Fine Tableware
                </p>
              </div>

              <div style={{ width: "150px", textAlign: "center" }}>
                <QRCodeCanvas
                  value={`${window.location.origin}/assets/pdf/food_package.pdf`}
                  size={80}
                  level="H"
                />
                <p style={{ marginTop: "10px", fontWeight: "500" }}>
                  Food Package
                </p>
              </div>

              <div style={{ width: "150px", textAlign: "center" }}>
                <QRCodeCanvas
                  value={`${window.location.origin}/assets/pdf/melamine.pdf`}
                  size={80}
                  level="H"
                />
                <p style={{ marginTop: "10px", fontWeight: "500" }}>Melamine</p>
              </div>

              <div style={{ width: "150px", textAlign: "center" }}>
                <QRCodeCanvas
                  value={`${window.location.origin}/assets/pdf/sachi_porcelain.pdf`}
                  size={80}
                  level="H"
                />
                <p style={{ marginTop: "10px", fontWeight: "500" }}>
                  Sachi Porcelain
                </p>
              </div>
            </div>
          </div>
        </section> */}

        <section
          className="product-area featured-product-area"
          data-aos="fade-up"
          data-aos-duration="1000"
          style={{ padding: "60px 0px 75px 0px", marginTop: "-60px" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-lg-6 m-auto">
                <div className="text-center">
                  <h2 className="title" style={{ marginBottom: "60px" }}>
                    <strong> Digital Catalogs </strong>
                  </h2>
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "30px",
              }}
            >
              {/* Sachi Products Fine Tableware Catalogue */}
              <div style={{ width: "200px", textAlign: "center" }}>
                <img
                  src="/assets/qrcodes/qr6.jpeg"
                  alt="Fine Tableware Catalogue QR"
                  style={{ width: "250px", height: "250px" }}
                />
                <p style={{ marginTop: "10px", fontWeight: "500" }}>
                  Sachi Products Fine Tableware Catalogue
                </p>
              </div>

              {/* Sachi Products 100% Melamine Catalogue */}
              <div style={{ width: "200px", textAlign: "center" }}>
                <img
                  src="/assets/qrcodes/qr5.jpeg"
                  alt="100% Melamine Catalogue QR"
                  style={{ width: "250px", height: "250px" }}
                />
                <p style={{ marginTop: "10px", fontWeight: "500" }}>
                  Sachi Products 100% Melamine Catalogue
                </p>
              </div>

              {/* Sachi Products Fine Porcelain Catalogue */}
              <div style={{ width: "200px", textAlign: "center" }}>
                <img
                  src="/assets/qrcodes/qr7.jpeg"
                  alt="Fine Porcelain Catalogue QR"
                  style={{ width: "250px", height: "250px" }}
                />
                <p style={{ marginTop: "10px", fontWeight: "500" }}>
                  Sachi Products Fine Porcelain Catalogue
                </p>
              </div>

              {/* Sachi Products Horeca Range */}
              <div style={{ width: "200px", textAlign: "center" }}>
                <img
                  src="/assets/qrcodes/qr3.jpeg"
                  alt="Horeca Range QR"
                  style={{ width: "250px", height: "250px" }}
                />
                <p style={{ marginTop: "10px", fontWeight: "500" }}>
                  Sachi Products Horeca Range
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="instagram-area section-space">
          <div className="container">
            <div className="row">
              <div
                className="col-lg-10 m-auto"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <div className="section-title text-center mb-5">
                  <h2 className="instagram-title">Follow us on Instagram</h2>
                  <p className="instagram-subtitle">@sachiproducts</p>
                  <div className="title-separator"></div>
                </div>

                <div className="instagram-feed-wrapper">
                  <div className="instagram-feed-container">
                    {instagramItems.map((item) => (
                      <div key={item.id} className="instagram-story-item">
                        <a
                          href={item.href}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div
                            className={`story-ring ${item.type === "add" ? "add-story" : ""}`}
                          >
                            <div className="story-white-inner">
                              <img
                                src={item.imageUrl}
                                alt={item.label}
                                className="story-img"
                              />
                            </div>
                          </div>
                          <p className="story-name">{item.label}</p>
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="quality-section section-space"
          style={{ backgroundImage: `url(${bgImage})` }}
        >
          <div className="quality-overlay"></div>

          <div className="container quality-container">
            <div className="row align-items-center">
              {/* LEFT SIDE TEXT */}
              <div className="col-lg-5 col-md-12 mb-5 mb-lg-0">
                <div className="quality-content" data-aos="fade-right">
                  <h6 className="sub-title">A Brand You Can Trust Upon</h6>
                  <h2 className="main-title">
                    Serving Best Quality Products{" "}
                    <span className="gold-text">Since 1996</span>
                  </h2>
                  <p className="description">
                    Over three decades of excellence in delivering premium
                    tableware and lifestyle products to our global patrons.
                  </p>
                  <Link to="/product" className="buy-now-btn">
                    Buy Now <i className="fas fa-arrow-right ms-2"></i>
                  </Link>
                </div>
              </div>

              {/* RIGHT SIDE STATS */}
              <div className="col-lg-7 col-md-12">
                <div className="stats-grid-wrapper" data-aos="fade-left">
                  <div className="stats-grid">
                    {[
                      { number: 1996, label: "Founding Year", suffix: "" },
                      { number: 45000, label: "Happy Clients", suffix: "+" },
                      { number: 30000, label: "Products", suffix: "+" },
                      { number: 30, label: "Years Success", suffix: "+" },
                      { number: 250, label: "Team Members", suffix: "+" },
                      { number: 2, label: "Outlets", suffix: "" },
                    ].map((item, index) => (
                      <div key={index} className="stat-card">
                        <h3 className="stat-number">
                          <CountUp end={item.number} duration={3} />
                          {item.suffix}
                        </h3>
                        <p className="stat-label">{item.label}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};
export default Home;
